module.exports = __webpack_public_path__ + "static/img/life_privileges-img-wg.c940607c.png";